import { render, staticRenderFns } from "./ClassroomMeetingCard.vue?vue&type=template&id=71b61fa5&"
import script from "./ClassroomMeetingCard.vue?vue&type=script&lang=js&"
export * from "./ClassroomMeetingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports